"use client";
import * as React from "react";
const SvgPlayCircleRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 720 800", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M303 285v230q0 18 15.5 27t30.5-1l181-116q14-9 14-25t-14-25L349 259q-15-10-30.5-1T303 285m97 515q-82 0-155-31.5t-127.5-86-86-127.5T0 400t31.5-155 86-127.5 127.5-86T400 0t155 31.5 127.5 86 86 127.5T800 400t-31.5 155-86 127.5-127.5 86T400 800m0-60q140 0 240-100t100-240-100-240T400 60 160 160 60 400t100 240 240 100" }));
export {
  SvgPlayCircleRound as default
};
